import {Directive, HostListener, Renderer2} from '@angular/core';

@Directive({
  selector: '[appCloseAlerts]'
})
export class CloseAlertsDirective {
  constructor(private renderer: Renderer2) { }

  @HostListener('click', ['$event']) onClick($event){
    let parentElm = ($event.currentTarget.parentElement.tagName.toLowerCase() == 'div' && $event.currentTarget.parentElement.classList.contains('alert')) ? $event.currentTarget.parentElement : $event.currentTarget.parentElement.parentElement;
    this.renderer.addClass(parentElm, 'fade');
    parentElm.classList.add('fade');
  }
}
